<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    
    <div class="col-xl-12 no-padding">
        <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
            <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                <span style="float:left">Submit new request</span>
            </h6>
        </div>
        <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
            <div class="col-md-12 col-sm-12 ">

                <div class="row small-section-content" style="margin-bottom:20px">
                    <div class="col-xl-12 text-center empty ">
                        <p style="text-align: left;">Do you want to learn more about the ideal GIS technology for your project? Schedule a demo or consultation with us. Our team is always ready to help you achieve success.</p>
                    </div>
                </div>

                <div class="col-md-12 col-sm-12 col-xs-12 b20-margin no-padding r20-padding l20-padding t30-padding b20-padding myG-box">
                    <div class="col-md-12 col-sm-12 col-xs-12 no-padding ">

                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <select class="form-select" id="floatingSelect" aria-label="Floating label select example" (change)="selectOption($event)">

                                    <option *ngFor="let request of requestFor" [value]="request.code">
                                        {{ request.name}}
                                    </option>
                                </select>
                                <label for="floatingSelect">Request For</label>
                            </div>
                        </div>

                        <div class="form-group col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-bottom:20px">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInputValueSubject" [(ngModel)]="userRequest.Subject">
                                <label for="floatingInputValueSubject">Subject</label>
                            </div>

                        </div>


                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="margin-bottom:20px">
                            <p style="margin:0px">
                                <small>{{descriptionLabel}}</small>
                            </p>
                            <div class="form-floating">
                                <textarea style="height:150px" [(ngModel)]="userRequest.Description" class="form-control" placeholder="Leave your description here..." id="floatingTextareaDescription"></textarea>
                                <label for="floatingTextareaDescription">Description</label>
                            </div>

                        </div>
                        <div class="form-group col-md-12 col-sm-12 col-xs-12 no-padding" style="text-align: right;">
                            <button [disabled]="btnVerifyDisabled" style="" class="btn mygistec-main-btn" (click)="addRequest()">{{btnVerifyText}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
       
</div>

